import {ExteriorColorGroup} from '../../kit/groups/ExteriorColorGroup';
import {isTrailerOrSemitrailer} from '../../kit/utils/isTrailerOrSemitrailer';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function VehicleStylingSubSection() {
  return (
    <VFKit.SubSection data-testid="vehicle-styling">
      <VFKit.ShowWhen
        name="type"
        condition={(type) => !isTrailerOrSemitrailer(type.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')}
      >
        <VFKit.BodyStyleColorTypeChips />

        <VFKit.Group data-testid="exterior-color" columns={[1, 2, 4]}>
          <ExteriorColorGroup />
        </VFKit.Group>

        <VFKit.InteriorMaterialChips />

        <VFKit.Group data-testid="interior-color" columns={[1, 2, 4]}>
          <VFKit.InteriorColorSelect />
          <VFKit.SimpleTextField name="interiorColorName" />
        </VFKit.Group>
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
